import { CODE_ERRORS } from '../../shared/constants';
import ROUTES from '../router/routes';

export const ERROR_DICTIONARY = {
  [ROUTES.DOCUMENT_VERIFICATION]: {
    [CODE_ERRORS.NOT_FOUND]: {
      message: 'Affiliate not found.',
      alertMessage: 'Verifica si el número de documento ingresado es correcto, no pudimos identificarte como afiliado a Prima AFP.'
    },
    [CODE_ERRORS.PRECONDITION_FAILED]: {
      message: 'Age requirements not met.',
      alertMessage: 'No cumples con la edad mínima requerida para acceder a la Pensión Mínima',
    },
  }
};